import { render, staticRenderFns } from "./ProductWidgets.vue?vue&type=template&id=4330e724&scoped=true&lang=html"
import script from "./ProductWidgets.vue?vue&type=script&lang=js"
export * from "./ProductWidgets.vue?vue&type=script&lang=js"
import style0 from "./ProductWidgets.vue?vue&type=style&index=0&id=4330e724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4330e724",
  null
  
)

export default component.exports